// Types for Cannes Outfit Planner

export interface User {
  id: number;
  email: string;
  name?: string;
}

export interface Event {
  id: number;
  user_id: number;
  name: string;
  start_date?: string;
  end_date?: string;
  total_days: number;
  created_at: string;
}

export interface Outfit {
  id: number;
  event_id: number;
  day_number: number;
  hair?: string;
  hair_images: string[];
  jewelry?: string;
  jewelry_images: string[];
  purse?: string;
  purse_images: string[];
  shoes?: string;
  shoes_images: string[];
  outfit?: string;
  outfit_images: string[];
  notes?: string;
  created_at: string;
  updated_at: string;
}

export interface OutfitUpdate {
  hair?: string;
  hair_images?: string[];
  jewelry?: string;
  jewelry_images?: string[];
  purse?: string;
  purse_images?: string[];
  shoes?: string;
  shoes_images?: string[];
  outfit?: string;
  outfit_images?: string[];
  notes?: string;
}

export interface ImageUpload {
  url: string;
  filename: string;
}

export type OutfitCategory = 'hair' | 'jewelry' | 'purse' | 'shoes' | 'outfit';

export interface Template {
  id: string;
  name: string;
  icon: string;
  categories: OutfitCategory[];
}

export const DEFAULT_TEMPLATES: Template[] = [
  { id: '2piece', name: 'template.2piece', icon: 'Layout', categories: ['outfit', 'jewelry', 'shoes', 'purse'] },
  { id: 'dress', name: 'template.dress', icon: 'Sparkles', categories: ['outfit', 'jewelry', 'shoes', 'purse', 'hair'] },
  { id: 'full', name: 'template.full', icon: 'Crown', categories: ['hair', 'jewelry', 'purse', 'shoes', 'outfit'] },
];
